export enum EqualizeBoostingActionEnum {
  BOOST = 'BOOST',
  BURY = 'BURY',
}
